import { Dimension, IDimensionMapper } from '@components/UI-Components/HierarchyWiseItems'
import {
  CATEGORY_INTERNAL_SEPERATOR,
  INDIVIDUAL_SEPARATOR_IDENTIFIER,
  PAGE_SEPARATOR_IDENTIFIER
} from '@components/UI-Components/HierarchyWiseItems/constants'
import { action, observable, ObservableMap } from 'mobx'
import { computedFn } from 'mobx-utils'
import { ItemType } from './PaginatedHierarchyItemsUIStore'

export type DefaultDimension = {
  [key in ItemType]?: Dimension
}

export class ItemDimensionStore implements IDimensionMapper {
  @observable dimensionsById = new ObservableMap()
  @observable.ref private default: DefaultDimension = {}
  @observable size = ''

  constructor(private rootId: string) {}

  @action
  setDefault = (dimension: DefaultDimension) => {
    this.default = { ...this.default, ...dimension }
  }

  @action
  setDimension = (id: string, dimension: Dimension, size?) => {
    this.dimensionsById.set(id, dimension)
    this.size = size
  }

  @action
  clearAll = () => {
    this.dimensionsById.clear()
  }

  ItemType = computedFn((id: string) => {
    if (id.includes(PAGE_SEPARATOR_IDENTIFIER)) {
      return ItemType.PAGE
    }
    if (id.includes(INDIVIDUAL_SEPARATOR_IDENTIFIER)) {
      return ItemType.INDIVIDUAL
    }
    if (id.includes(CATEGORY_INTERNAL_SEPERATOR)) {
      return ItemType.CATEGORY
    }
    if (id === this.rootId) {
      return ItemType.ROOT
    }
    return ItemType.CATEGORY
  })

  dimension = computedFn<(id: string) => Dimension>((id: string) => {
    return this.dimensionsById.get(id) || this.default[this.ItemType(id)]
  })
}
